module.exports = __webpack_public_path__ + "img/noCon.50319e90.png";